import { Checkbox } from 'components/1-atoms/Checkbox';
import { useEffect, useState } from 'react';
import styles from '../NewsLetterSignUp.module.scss';

export type NewsLetterSignUpCheckBoxProps = {
	required: boolean;
	idName: string;
	lblName: string;
	submitTried: boolean;
	options: { name: string; idValue: string; idName: string }[];
	onChange?: (formElement: HTMLFormElement) => void;
	errorText: string;
};

export const NewsLetterSignUpCheckBox: React.FC<NewsLetterSignUpCheckBoxProps> = ({
	required,
	idName,
	lblName,
	submitTried,
	onChange,
	options,
	errorText,
}) => {
	const [checkedValues, setCheckedValue] = useState<{ name: string; idValue: string; idName: string; checked: boolean }[]>(
		options?.map((option) => {
			const stateOption = { ...option, checked: false };
			return stateOption;
		}),
	);
	const [error, setError] = useState<string>(undefined);

	useEffect(() => {
		if (required && checkedValues.every((cv) => cv.checked === false) && submitTried) {
			setError(errorText);
		} else {
			setError(undefined);
		}
	}, [submitTried, checkedValues, required]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const checked = e?.target?.checked;

		const updatedOptions = checkedValues?.map((option) => {
			if (option.idValue === e?.target?.value) option.checked = checked;
			return option;
		});
		setCheckedValue(updatedOptions);
		onChange && onChange(e.target.form);
	};

	return (
		<fieldset>
			<legend>{lblName}</legend>
			{options?.map((o) => (
				<Checkbox
					key={o.idName}
					id={o.idName}
					value={o.idValue}
					label={o.name}
					name={idName}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
					required={required && checkedValues.every((cv) => cv.checked === false)}
				/>
			))}
			{error && <p className={styles.NewsLetterSignUp___error}>{error}</p>}
		</fieldset>
	);
};
